import StatementSummaryModal from './statement-summary-viewer-modal';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { BUTTON_TYPES } from 'components/common/button-component';
import { ReactComponent as OmniaAIIcon } from 'icons/omnia-ai.svg';
import Tooltip from 'components/common/tool-tip-component';
import { connect } from 'react-redux';
import {
  SUMMARY_AI_BLOCK,
  SUMMARY_AI_BLOCK_ID,
} from 'constants/feature/statement-content-constants';

const StatementSummaryViewerComponent = ({
  summary,
  statement
}) => {
  const [isSummaryModalOpen, setIsSummaryModalOpen] = useState(false);

  return (
    <>
      <div className={`${SUMMARY_AI_BLOCK}__summary_button_container`}>
        <Tooltip
          id={`${SUMMARY_AI_BLOCK_ID}-summary-ai-tooltip`}
          text={'global-header-statement-summary-button-tooltip'}
          position="bottom"
        >
          <FormattedMessage id={'global-header-statement-summary.button'} />
          <button
            id={`${SUMMARY_AI_BLOCK_ID}__summary_button`}
            className={`${SUMMARY_AI_BLOCK}__summary_button_container--button`}
            type={BUTTON_TYPES.tertiary}
            onClick={() => setIsSummaryModalOpen(!isSummaryModalOpen)}
          >
            <OmniaAIIcon />
          </button>
        </Tooltip>
      </div>
      {isSummaryModalOpen && (
        <StatementSummaryModal
          onClose={() => setIsSummaryModalOpen(!isSummaryModalOpen)}
          summary={summary}
        />
      )}
    </>
  );
};
StatementSummaryViewerComponent.propTypes = {
  /** Summary of the statement */
  summary: PropTypes.object
};
const mapStateToProps = ({
  data: {
    revision,
  }
}) => ({
  statement: revision
});

export { StatementSummaryViewerComponent };
export default connect(
  mapStateToProps,
)(StatementSummaryViewerComponent);
